var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );
dependencies["shipping/pdp-flat-rate-shipping.j2"] = require( "shipping/pdp-flat-rate-shipping.j2" );
dependencies["shipping/pdp-collection-points-message.j2"] = require( "shipping/pdp-collection-points-message.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/shipping/pdp-shipping-information.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/render-entry.j2", false, "product/templates/shipping/pdp-shipping-information.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderEntry")) {
var t_4 = t_1.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_4);
var t_5;
t_5 = (lineno = 2, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.shippingInfoEntry"]));
frame.set("productShippingInfoEntry", t_5, true);
if(frame.topLevel) {
context.setVariable("productShippingInfoEntry", t_5);
}
if(frame.topLevel) {
context.addExport("productShippingInfoEntry", t_5);
}
output += "\n";
var t_6;
t_6 = (lineno = 3, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.shippingModules.pdp-shipping-table"]));
frame.set("defaultShippingInfoEntry", t_6, true);
if(frame.topLevel) {
context.setVariable("defaultShippingInfoEntry", t_6);
}
if(frame.topLevel) {
context.addExport("defaultShippingInfoEntry", t_6);
}
output += "\n";
var t_7;
t_7 = (!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku")),"sku") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"hasFlatRateSku")) || (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku")),"sku") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productDetails")),"isFlatRate"));
frame.set("isFlatRate", t_7, true);
if(frame.topLevel) {
context.setVariable("isFlatRate", t_7);
}
if(frame.topLevel) {
context.addExport("isFlatRate", t_7);
}
if(runtime.contextOrFrameLookup(context, frame, "productShippingInfoEntry")) {
output += runtime.suppressValue((lineno = 8, colno = 16, runtime.callWrap(t_4, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "productShippingInfoEntry")])), env.opts.autoescape);
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isFlatRate")) {
env.getTemplate("shipping/pdp-flat-rate-shipping.j2", false, "product/templates/shipping/pdp-shipping-information.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "defaultShippingInfoEntry")) {
output += runtime.suppressValue((lineno = 16, colno = 16, runtime.callWrap(t_4, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "defaultShippingInfoEntry")])), env.opts.autoescape);
;
}
;
}
;
}
env.getTemplate("shipping/pdp-collection-points-message.j2", false, "product/templates/shipping/pdp-shipping-information.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
output += t_13
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/shipping/pdp-shipping-information.j2"] , dependencies)